import script from "./PwaNoticeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaNoticeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PwaNoticeDetail.vue?vue&type=style&index=0&id=4842dacc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4842dacc"]])

export default __exports__